<template>
  <div class="container section">
    <div class="row heading">
      <div class="col">
        <h2>Contacts</h2>
      </div>
    </div>
    <div class="row table-head" >
      <div class="col">Title</div>
      <div class="col">Name</div>
      <div class="col">Tel No.</div>
      <div class="col">Email</div>
      <div class="col">Fax No.</div>
      <div class="col-2"></div>
    </div>

    <div class="row lined" v-for="v, i in accountContacts" :key="v.contact_id" >

      <div class="col" @click="setSelected(v)" >
        <span v-show="!selected || selected.accountContact_id !== v.accountContact_id">{{v.title}}</span>
        <input v-show="selected && selected.accountContact_id == v.accountContact_id" type="text" class="form-control" v-model="selected.title" />

      </div>
      <div class="col" @click="setSelected(v)" >
        <span v-show="!selected || selected.accountContact_id != v.accountContact_id" > {{v.name}} </span>
        <input v-show="selected && selected.accountContact_id == v.accountContact_id" type="text" class="form-control" v-model="selected.name" />
      </div>
      <div class="col" @click="setSelected(v)" >

        <span v-show="!selected || selected.accountContact_id != v.accountContact_id" > {{v.telno}} </span>
        <input v-show="selected && selected.accountContact_id == v.accountContact_id" type="text" class="form-control" v-model="selected.telno" />

      </div>
      <div class="col" @click="setSelected(v)" >

        <span v-show="!selected || selected.accountContact_id != v.accountContact_id" > {{v.email}} </span>
        <input v-show="selected && selected.accountContact_id == v.accountContact_id" type="text" class="form-control" v-model="selected.email" />

      </div>
      <div class="col" @click="setSelected(v)" >

        <span v-show="!selected || selected.accountContact_id != v.accountContact_id" > {{v.faxno}} </span>
        <input v-show="selected && selected.accountContact_id == v.accountContact_id" type="text" class="form-control" v-model="selected.faxno" />

      </div>
      <div class="col-2">
        <div class="col-form-label text-right" v-show="selected && selected.accountContact_id == v.accountContact_id">
          <button class="btn btn-sm btn-success" @click.stop="update"><i class="fa fa-check"></i></button>
          <button class="btn btn-sm btn-danger" @click.stop="cancel"><i class="fa fa-close"></i></button>
        </div>

        <div class="col-form-label text-right" v-show="!selected || selected.accountContact_id != v.accountContact_id">
          <dropdown-confirmation @confirm="deleteContact(v)"></dropdown-confirmation>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col">
        <button class="btn btn-primary" @click="resetSelected(); showAddContact = true;"><i class="fa fa-plus"></i> &nbsp;Add Contact</button>
      </div>
    </div>

    <modal v-if="showAddContact" allow-click-away="false">
      <div slot="header">
        <h3 class="modal-title d-inline d-flex justify-content-start">Add Contact</h3>
          <button type="button" class="btn btn-clear close-btn" @click="resetSelected(); showAddContact = false">
            <i class="fa fa-remove"  />
          </button>
        </h3>
      </div>
      <div slot="body">
        <div class="row">
          <div class="col-4">Title</div>
          <div class="col-8 col-sm-6">
            <input type="text" class="form-control" v-model="selected.title" />
          </div>
        </div>
        <div class="row">
          <div class="col-4">Name</div>
          <div class="col-8 col-sm-6">
            <input type="text" class="form-control" v-model="selected.name" />
          </div>
        </div>
        <div class="row">
          <div class="col-4">Email</div>
          <div class="col-8 col-sm-6">
            <input type="text" class="form-control" v-model="selected.email" />
          </div>
        </div>
        <div class="row">
          <div class="col-4">Fax</div>
          <div class="col-8 col-sm-6">
            <input type="text" class="form-control" v-model="selected.faxno" />
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-clear" @click.stop="resetSelected(); showAddContact = false">Cancel</button>
          <button class="btn btn-primary" @click.stop="saveNew()"><i class="fa fa-check"></i> Save Contact</button>
        </div>
      </div>
    </modal>

  </div>
</template>
<script type="text/babel">
  import Modal from '../assets/Modal.vue';
  import DropdownConfirmation from '../assets/DropdownConfirmation.vue';
  export default {
    name: 'AccountContacts',
    data: function(){
      return {
        params: {
          data: {
            account_id: ''
          }
        },
        showAddContact:false,
        selected: {
          accountContact_id:'',
          name: '',
          title: '',
          telno: '',
          email: '',
          faxno: ''
        }
      }
    },

    created(){
      this.params.data.account_id = this.$route.params.account_id;
    },
    computed:{

    },
    components:{
      DropdownConfirmation,
      Modal
    },
    methods:{
      cancel(){
        this.resetSelected();
      },
      resetSelected(){
        this.selected = {
          accountContact_id:'',
          name: '',
          title: '',
          telno: '',
          email: '',
          faxno: ''
        };
      },
      setSelected(v){
        if(this.selected.accountContact_id != v.accountContact_id){
          this.selected = JSON.parse(JSON.stringify(v));
        }
      },
      saveNew(){
        this.$emit('accountContactsUpdate', this.selected);
        this.$nextTick(function(){
          this.resetSelected();
          this.showAddContact = false;
        });
      },
      update(i){
        this.$emit('accountContactsUpdate', this.selected);
        this.$nextTick(function(){
          this.selected = {};

        });
      },
      deleteContact(v){
        this.$emit('accountContactsDelete', v);
        this.$nextTick(function(){
          this.selected = {};
        });
      }
    },
    props:{
      details: {
        type: Object
      },
      accountContacts:{
        type: Array
      }
    }

  }

</script>



// WEBPACK FOOTER //
// AccountContacts.vue?488c6890